import {testResumableEndpoint} from './uploadResumable';
import {useResumableUploadQueue, type ResumableQueueApi} from './useResumableUploadQueue';

// TEMP: ідентичний пайплайн до основного аплоадера (resumable, чанки, ретраї,
// idempotency) — лише фіксована тимчасова папка TEST і нема нічого, що
// потребувало б автентифікації / анкети. Коли потреба зникне, файл просто
// видаляється цілком.

export function useTestUploadQueue(): ResumableQueueApi {
  return useResumableUploadQueue({endpoint: testResumableEndpoint});
}
